import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Kategorie from "../views/Kategorie"
import Betrieb from "../views/Betrieb"
import About from "../views/About"

Vue.use(VueRouter);

const parsePropId = r => ({ id: parseInt(r.params.id) });
const parseCatProps = r => ({ title: r.params.title, id: parseInt(r.params.id) });

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/kategorie/:title/:id',
    name: 'kategorie-detail',
    component: Kategorie,
    props: parseCatProps,
  },
  {
    path: '/betrieb/:id',
    name: 'betrieb-detail',
    component: Betrieb,
    props: parsePropId,
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
